import React from 'react';

const Header = ({ profile }) => {
  return (
    <header className="container hero">
      <div className="profile" id="aboutMe">
        <div className="profile-content">
          <h1 className="text-primary">Fadli<span className="break"></span> Hidayatullah</h1>
          <h4>{ profile.role }</h4>
          <p>{ profile.bio }</p>
          <a href="mailto:fadlihdytullah@gmail.com" rel="noopener noreferrer">Hire Me</a>
        </div>
      </div>
      <div className="image-profile">
        <img src="images/me.png" alt="Fadli Hidayatullah's" />
      </div>
    </header>
  );
}

export default Header;